import { CountryIso2 } from "react-international-phone";

export const localeToCountry: Record<string, CountryIso2> = {
  "pt-BR": "br", // Brasil
  "en": "us",    // Estados Unidos
}